// extracted by mini-css-extract-plugin
module.exports = {"root":"FileBtn_root__1e0s6","disabled":"FileBtn_disabled__1CyN6","warn":"FileBtn_warn__2crdu","fade":"FileBtn_fade__2zRfI"};